"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var StoreSpecificationEnum_1 = require("../../promotion/model/StoreSpecificationEnum");
/**
 * @author OPt
 */


var ForecastCoordinatorTreeDataDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ForecastCoordinatorTreeDataDTO, _DomainObject_1$Domai);

  /**
   * @param entityName
   *          – Both: name of the entity ∈ { Window; WindowItem }
   * @param windowId
   * @param windowItemId
   * @param storeSpecification
   *          – Window: Promotion.storeSpecification
   *          – WindowItem: –
   * @param promotionName
   *          – Window: Promotion.name
   *          – WindowItem: –
   * @param promotionCode
   *          – Window: Promotion.externalId
   *          – WindowItem: –
   * @param promotionId
   *          - Window: promotion.id
   *          - WindowItem: promotion.id
   *          – Window: Window.dateFrom.isoWeek()
   *          – WindowItem: –
   * @param windowName
   *          – Window: Window.name
   *          – WindowItem: –
   * @param windowTypeId
   *          – Window: Window.windowTypeId
   *          – WindowItem: –
   * @param approveActionType
   * @param dateFrom
   *          – Window: Window.dateFrom
   *          – WindowItem: –
   * @param dateTo
   *          – Window: Window.dateTo
   *          – WindowItem: –
   * @param productId
   * @param productExternalId
   * @param productName
   *          – Window: –
   *          – WindowItem: Product.name
   * @param systemVolume
   *          – Window: sum(WindowItem[i].systemVolume)
   *          – WindowItem: WindowItem.systemVolume
   * @param promoVolume
   *          – Window: sum(WindowItem[i].promoVolume)
   *          – WindowItem: WindowItem.promoVolume
   * @param lastPromoVolumeUpdate
   * @param salesSystemVolume
   *          – Window: sum(WindowItem[i].systemVolume * WindowItem[i].promoPrice)
   *          – WindowItem: WindowItem.systemVolume * WindowItem.promoPrice
   * @param salesPromoVolume
   *          – Window: sum(WindowItem[i].promoVolume * WindowItem[i].promoPrice)
   *          – WindowItem: WindowItem.promoVolume * WindowItem.promoPrice
   * @param volumeDifferencePiece
   *          – Window: sum(WindowItem[i].systemVolume - WindowItem[i].promoVolume)
   *          – WindowItem: WindowItem.systemVolume - WindowItem.promoVolume
   * @param volumeDifferencePercentage
   *          – Window: sum(WindowItem[i].systemVolume - WindowItem[i].promoVolume) / sum(WindowItem[i].systemVolume)
   *          – WindowItem: (WindowItem.systemVolume - WindowItem.promoVolume) / WindowItem.systemVolume
   * @param approvalLimitPiece
   *          – Both: threshold limit (pieces)
   * @param approvalLimitPercentage
   *          – Both: threshold limit (percentage)
   * @param promoPrice
   *          – Window: null
   *          – WindowItem: WindowItem.promoPrice
   * @param regularPrice
   *          – Window: null
   *          – WindowItem: WindowItem.regularPrice
   * @param secondaryPlacement
   *          – Window: null
   *          – WindowItem: WindowItem.secondaryPlacement
   * @param numberOfSites
   *          – Window: null
   *          – WindowItem: WindowItem.siteData.size
   * @param cmForecast
   * @param onPicture
   */
  function ForecastCoordinatorTreeDataDTO(entityName, windowId, windowItemId, storeSpecification, promotionName, promotionCode, promotionId, windowName, windowTypeId, approveActionType, dateFrom, dateTo, productId, productExternalId, productName, systemVolume, promoVolume, lastPromoVolumeUpdate, salesSystemVolume, salesPromoVolume, volumeDifferencePiece, volumeDifferencePercentage, approvalLimitPiece, approvalLimitPercentage, promoPrice, regularPrice, secondaryPlacement, numberOfSites, //
  cmForecast, onPicture) {
    var _this;

    _classCallCheck(this, ForecastCoordinatorTreeDataDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ForecastCoordinatorTreeDataDTO).call(this));
    _this.entityName = entityName;
    _this.windowId = windowId;
    _this.windowItemId = windowItemId;
    _this.storeSpecification = storeSpecification;
    _this.promotionName = promotionName;
    _this.promotionCode = promotionCode;
    _this.promotionId = promotionId;
    _this.windowName = windowName;
    _this.windowTypeId = windowTypeId;
    _this.approveActionType = approveActionType;
    _this.dateFrom = dateFrom;
    _this.dateTo = dateTo;
    _this.productId = productId;
    _this.productExternalId = productExternalId;
    _this.productName = productName;
    _this.systemVolume = systemVolume;
    _this.promoVolume = promoVolume;
    _this.lastPromoVolumeUpdate = lastPromoVolumeUpdate;
    _this.salesSystemVolume = salesSystemVolume;
    _this.salesPromoVolume = salesPromoVolume;
    _this.volumeDifferencePiece = volumeDifferencePiece;
    _this.volumeDifferencePercentage = volumeDifferencePercentage;
    _this.approvalLimitPiece = approvalLimitPiece;
    _this.approvalLimitPercentage = approvalLimitPercentage;
    _this.promoPrice = promoPrice;
    _this.regularPrice = regularPrice;
    _this.secondaryPlacement = secondaryPlacement;
    _this.numberOfSites = numberOfSites;
    _this.cmForecast = cmForecast;
    _this.onPicture = onPicture;
    return _this;
  }

  return ForecastCoordinatorTreeDataDTO;
}(DomainObject_1.DomainObject);

exports.ForecastCoordinatorTreeDataDTO = ForecastCoordinatorTreeDataDTO;

ForecastCoordinatorTreeDataDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ForecastCoordinatorTreeDataDTO.name);
  return {
    entityName: builder.str('entityName'),
    windowId: builder.str('windowId'),
    windowItemId: builder.opt(builder.str('windowItemId')),
    storeSpecification: builder.opt(builder.senum('storeSpecification', StoreSpecificationEnum_1.StoreSpecificationEnum, CodebookLookupSequence_1.CodebookLookupSequence.StoreSpecification)),
    promotionName: builder.opt(builder.str('promotionName')),
    promotionCode: builder.opt(builder.str('promotionCode')),
    promotionId: builder.opt(builder.str('promotionId')),
    windowName: builder.opt(builder.str('windowName')),
    windowTypeId: builder.opt(builder.id('windowTypeId')),
    approveActionType: builder.opt(builder.str('approveActionType')),
    dateFrom: builder.opt(builder.date('dateFrom')),
    dateTo: builder.opt(builder.date('dateTo')),
    productId: builder.opt(builder.id('productId')),
    productExternalId: builder.opt(builder.str('productExternalId')),
    productName: builder.opt(builder.str('productName')),
    systemVolume: builder.bigNum('systemVolume'),
    promoVolume: builder.bigNum('promoVolume'),
    lastPromoVolumeUpdate: builder.opt(builder.date('lastPromoVolumeUpdate', DateParser_1.DateParser.ISO_PATTERN)),
    salesSystemVolume: builder.bigNum('salesSystemVolume'),
    salesPromoVolume: builder.bigNum('salesPromoVolume'),
    volumeDifferencePiece: builder.opt(builder.bigNum('volumeDifferencePiece')),
    volumeDifferencePercentage: builder.opt(builder.bigNum('volumeDifferencePercentage')),
    thresholdPiece: builder.bigNum('thresholdPiece'),
    thresholdPercentage: builder.bigNum('thresholdPercentage'),
    approvalLimitPiece: builder.bigNum('approvalLimitPiece'),
    approvalLimitPercentage: builder.bigNum('approvalLimitPercentage'),
    promoPrice: builder.opt(builder.bigNum('promoPrice')),
    regularPrice: builder.opt(builder.bigNum('regularPrice')),
    secondaryPlacement: builder.opt(builder.str('secondaryPlacement')),
    numberOfSites: builder.opt(builder.num('numberOfSites')),
    //
    cmForecast: builder.opt(builder.bigNum('cmForecast')),
    onPicture: builder.opt(builder.bool('onPicture'))
  };
}();